import styled from 'styled-components'
import { cores } from '../../styles'

export const PageContainer = styled.div`
  background-color: ${cores.corPrincipalDown};
  height: 100dvh;
`
